<template>
    <div>
    <header class="topbar">
        <a href="/account/dashboard" class="topbar-brand"><img src="/images/logo.svg" /></a>
        <div class="headerMenuHamburger" @click="toggleMenu()"><a href="#" title="Show Menu">Menu</a></div>
        <nav class="navbar">
          <!-- <ul id="topbarnav">
              <li v-if="hasRole('user')"><a href="/objects"><i class="fas fa-building"></i> <span>Objekte</span></a></li>
              <li v-if="hasRole('admin')"><a href="#"><i class="fas fa-user-clock fa-fw"></i> <span>Users</span></a>
                  <div class="topbarnav-dd">
                      <ul>
                          <li><router-link to="/users/administrators" exact>Administrators</router-link></li>
                          <li><router-link to="/users/general-partners" exact>General Partners</router-link></li>
                      </ul>
                  </div>
              </li> -->
            <!--  <li v-if="hasRole('admin')"><a href="#"><i class="fas fa-file"></i> <span>Seiten</span></a>
                <div class="topbarnav-dd" style="margin-left: -25px;width:160px;">
                  <ul>
                    <li><router-link to="#" exact>FAQs</router-link></li>
                    <li><router-link to="#" exact>Standard</router-link></li>
                  </ul>
                </div>
              </li>
                <li v-if="hasRole('admin')"><a href="#"><i class="fas fa-cog"></i> <span>Einstellungen</span></a>
                  <div class="topbarnav-dd" style="margin-left: -25px;width:240px;">
                    <ul>
                      <li><router-link to="#" exact>Zentrale Leistungen</router-link></li>
                      <li><router-link to="#" exact>Saisonzeiten</router-link></li>
                     </ul>
                  </div>
                </li>
                <li class="logout"><a href="#" @click.prevent="logout"><i class="fas fa-power-off"></i> <span>Logout</span></a></li>
            </ul> -->
          <div class="user-info">
            Logged in as: <strong>{{ getAuthUser('full_name') }}</strong>
            <a href="#" class="logout" @click.prevent="logout"><i class="fas fa-power-off"></i> <span>Logout</span></a>
          </div>
        </nav>        
    </header>
    </div>
</template>
<script>
    export default {
        mounted() {

        },
        data() {
            return { }
        },
        methods : {
            toggleMenu(){
               $('body').toggleClass("show_menu");
            },
            logout(){
                helper.logout().then(() => {
                    this.$store.dispatch('resetAuthUserDetail');
                    this.$router.push('/login')
                })
            },
            hasRole(role){
              return helper.hasRole(role);
            },
            getAuthUser(name){
                return helper.getAuthUser(name);
            },
            getConfig(name){
                return helper.getConfig(name);
            },
            hasPermission(permission){
                return helper.hasPermission(permission);
            },
        },
        computed: {
            getMainLogo(){
                if(helper.getConfig('main_logo'))
                    return '/'+helper.getConfig('main_logo');
                else
                    return '/images/default_main_logo.png';
            },
            getSidebarLogo(){
                if(helper.getConfig('sidebar_logo'))
                    return '/'+helper.getConfig('sidebar_logo');
                else
                    return '/images/default_sidebar_logo.png';
            }
        }
    }
</script>
